// extracted by mini-css-extract-plugin
export default {"container":"SensorStatusMobile_container__xeJPG","no-scrollbar":"SensorStatusMobile_no-scrollbar__oVi1j"};